import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import Img from "gatsby-image"
import CalendarIcon from "../images/calendar.png"
import { Link } from "gatsby"

const Posts = props => {
  return (
    <Container className="posts">
      {props.posts.edges.map((post, index) => (
        <Row key={index} className="post">
          <Col lg={{ span: 5, offset: 1 }}>
            <Link to={post.node.path} title={post.node.title}>
              <Img
                fluid={
                  post.node.acf.image_for_listing.localFile.childImageSharp
                    .fluid
                }
              />
            </Link>
          </Col>
          <Col lg={{ span: 5 }}>
            <h1 className="post-title">{post.node.title}</h1>
            <p>
              <img class="calendar-icon" src={CalendarIcon} alt="" />
              {post.node.date} by <strong>{post.node.author.name}</strong>
            </p>
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: post.node.excerpt }}
            />
            <Link className="more" to={post.node.path}>
              More {` `}
              <span>&#10230;</span>
            </Link>
          </Col>
        </Row>
      ))}
    </Container>
  )
}

export default Posts
